// src/features/frighi/CryoChart.jsx
import React from "react";
import {
  ResponsiveContainer,
  LineChart,
  Line,
  XAxis,
  YAxis,
  CartesianGrid,
  Tooltip,
  ReferenceLine,
} from "recharts";
import { useCryoHistory } from "./useCryoHistory";

function EmptyBox({ children }) {
  return (
    <div className="w-full py-6 text-center text-sm text-gray-500">
      {children}
    </div>
  );
}

export default function CryoChart({
  mac,
  days = 30,
  height = 220,
  min = null,
  max = null,
}) {
  const { data, loading, error } = useCryoHistory(mac, { days });

  if (!mac) return <EmptyBox>MAC non specificato.</EmptyBox>;
  if (loading) return <EmptyBox>Caricamento grafico…</EmptyBox>;
  if (error) return <EmptyBox>Errore grafico: {error}</EmptyBox>;
  if (!data.length) return <EmptyBox>Nessun dato storico nel periodo selezionato.</EmptyBox>;

  const tickFmt = (v) => {
    const dt = new Date(v);
    if (days <= 1) {
      return dt.toLocaleTimeString("it-IT", { hour: "2-digit", minute: "2-digit" });
    }
    return dt.toLocaleString("it-IT", { day: "2-digit", month: "2-digit", hour: "2-digit", minute: "2-digit" });
  };

  return (
    <div style={{ width: "100%", height }}>
      <ResponsiveContainer>
        <LineChart data={data}>
          <CartesianGrid strokeDasharray="3 3" />
          <XAxis dataKey="t" tickFormatter={tickFmt} minTickGap={20} />
          <YAxis />
          <Tooltip labelFormatter={(v) => new Date(v).toLocaleString("it-IT")} />

          {min != null && (
            <ReferenceLine
              y={min}
              stroke="red"
              strokeDasharray="3 3"
              label={{ value: `Min ${min}°C`, position: "insideTopLeft", fontSize: 10 }}
            />
          )}
          {max != null && (
            <ReferenceLine
              y={max}
              stroke="red"
              strokeDasharray="3 3"
              label={{ value: `Max ${max}°C`, position: "insideTopLeft", fontSize: 10 }}
            />
          )}

          <Line type="monotone" dataKey="y" dot={false} strokeWidth={2} />
        </LineChart>
      </ResponsiveContainer>
    </div>
  );
}
